export default __webpack_public_path__ + "static/media/Saturday_02.7b294278.png";